import { createAction, createReducer, on, props } from '@ngrx/store';

// Action Types
export const resetPrice = createAction('resetPrice');
export const updatePriceObject = createAction('updatePriceObject', props<{ priceObj: any }>());
export const updatePriceStatus = createAction('updatePriceStatus', props<{ priceLoading: boolean }>());
export const amendPaymentConfirmed = createAction('amendPaymentConfirmed', props<{ confirmed: boolean }>());
export const refreshPriceObject = createAction('refreshPriceObject');
export const updateSbbSubsidyAmount = createAction('updateSbbSubsidyAmount', props<{ subsidyAmount: number }>());

// Initial State
export interface PriceState {
  price: any;
  sbbSubsidyAmount: number;
  amendPaymentConfirmed: boolean;
  priceCount: number;
  priceLoading: boolean;
}

const initialState: PriceState = {
  price: {},
  sbbSubsidyAmount: 0,
  amendPaymentConfirmed: false,
  priceCount: 0,
  priceLoading: false
};

// Reducer using NgRx `createReducer` and `on`
export const priceReducer = createReducer(
  initialState,
  on(updatePriceObject, (state, { priceObj }) => ({
    ...state,
    price: priceObj,
    priceCount: 0,
    priceLoading: false
  })),
  on(refreshPriceObject, state => ({
    ...state,
    priceCount: state.priceCount + 1
  })),
  on(updatePriceStatus, (state, { priceLoading }) => ({
    ...state,
    priceLoading
  })),
  on(resetPrice, () => ({
    ...initialState
  })),
  on(amendPaymentConfirmed, (state, { confirmed }) => ({
    ...state,
    amendPaymentConfirmed: confirmed
  })),
  on(updateSbbSubsidyAmount, (state, { subsidyAmount }) => ({
    ...state,
    sbbSubsidyAmount: subsidyAmount
  }))
);
